import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { editAdmin, getAdminInfo, getRoleList } from '../../actions/permissionsAction'
import EditAdminView from "../../containers/AdminUsers/CreateAdmin/CreateAdmin"
const EditAdmin = ({ match,history }) => {
  const dispatch = useDispatch()
  const { adminInfo } = useSelector(state => state.permissionsAdmin)
  const { listRoleAdmin } = useSelector(state => state.permissionsAdmin)
  useEffect(() => {
    dispatch(getAdminInfo(match.params.adminID))
    return () => {
    }
  }, [match.params.adminID])
  useEffect(() => {
    dispatch(getRoleList())

    return () => {

    }
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      name: adminInfo?.name || "",
      phone: adminInfo?.phone || "",
      gender: adminInfo?.gender || "",
      description: adminInfo?.description || "",
      adminRoleId:adminInfo?.adminRoleId?.lenght>0 ? adminInfo?.adminRoleId[0]._id : "",
      birthDate: adminInfo?.birthDate || "",
    },
    onSubmit: (({ files, name, phone, gender, description, adminRoleId, birthDate }) => {
      const formData = new FormData()
      formData.append("adminUserId", adminInfo._id)
      
      if (files) {
        formData.append("files", files)
      }
      formData.append("name", name)
      formData.append("phone", phone)
      formData.append("gender", gender)
      formData.append("description", description)
      formData.append("adminRoleId", adminRoleId)
      formData.append("birthDate", birthDate)
      dispatch(editAdmin(formData, history))

    })

  })
  return (
    <EditAdminView admin={adminInfo} formik={formik} roles={listRoleAdmin} isEdit={true} />
  )
}

export default EditAdmin